export enum TouchType {
  DEFAULT,
  TARGET,
  CHANGED,
}
